import { Button, HStack, IconButton, Select, Text } from '@chakra-ui/react';
import { useMemo } from 'react';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa6';

export interface PageSizePaginationFooterProps {
  totalLength: number;
  visibleLength: number;
  page: number;
  setPage(n: number): void;
  pageSize: number;
  setPageSize(n: number): void;
  disabled?: boolean;
  /** Se definido, substitui as opções padrão (10–30 conforme total). */
  pageSizes?: number[];
}

const PageSizePaginationFooter: React.FC<PageSizePaginationFooterProps> = ({
  totalLength,
  visibleLength,
  page,
  setPage,
  pageSize,
  setPageSize,
  disabled = false,
  pageSizes,
}) => {
  const pageCount = useMemo(
    () => Math.max(1, Math.ceil(totalLength / pageSize)),
    [totalLength, pageSize],
  );

  return (
    <HStack
      borderColor="gray.200"
      borderWidth="1px"
      justify="space-between"
      p="1rem"
      rounded="5px"
      wrap="wrap"
    >
      <Select
        w="fit-content"
        value={pageSize}
        isDisabled={disabled}
        onChange={(e) => setPageSize(Number(e.target.value))}
      >
        {pageSizes ? (
          pageSizes.map((n) => (
            <option key={n} value={n}>
              Exibir {n} itens
            </option>
          ))
        ) : (
          <>
            <option value={10}>Exibir 10 itens</option>
            {totalLength > 10 && <option value={15}>Exibir 15 itens</option>}
            {totalLength > 15 && <option value={20}>Exibir 20 itens</option>}
            {totalLength > 20 && <option value={25}>Exibir 25 itens</option>}
            {totalLength > 25 && <option value={30}>Exibir 30 itens</option>}
          </>
        )}
      </Select>

      <Text>
        {visibleLength} {visibleLength > 1 ? 'itens' : 'item'}
      </Text>

      <HStack wrap={{ base: 'wrap', sm: 'nowrap' }}>
        <IconButton
          variant="ghost"
          rounded="full"
          aria-label="Anterior"
          icon={<FaAngleLeft />}
          onClick={() => setPage(page - 1)}
          isDisabled={disabled || page === 1}
        />

        {Array.from({ length: pageCount }, (_, idx) => (
          <Button
            variant={page === idx + 1 ? 'filled' : 'ghost'}
            colorScheme="gray"
            rounded="full"
            key={idx + 1}
            onClick={() => setPage(idx + 1)}
            isDisabled={disabled}
          >
            {idx + 1}
          </Button>
        ))}

        <IconButton
          variant="ghost"
          rounded="full"
          aria-label="Próximo"
          icon={<FaAngleRight />}
          onClick={() => setPage(page + 1)}
          isDisabled={disabled || page === pageCount}
        />
      </HStack>
    </HStack>
  );
};

export default PageSizePaginationFooter;
